import React, { Component } from 'react';
import Accordion from '../ui/accordion';
import Loading from '../ui/loading-spinner';
import BuildTable from './tables/buildtable';

class Alerts extends Component {
    componentDidMount() {
        this.props.fetchAllAlerts();
        this.props.resetBadgeCount();
    }

    componentWillUnmount() {
        this.props.setNewTasksVisited();
    }

    render() {
        let accordionData = [];
        let validMcrc =
            this.props.userInfo.Billet.location === 'MCRC' ? true : false;
        let pastDueTotalCount;
        let returnedForEditTable;

        if (!validMcrc) {
            pastDueTotalCount =
                this.props.pastDueNeedsReview.length +
                this.props.pastDueReturnedForEdit.length +
                this.props.pastDueIncompleteAfterActions.length;
            returnedForEditTable = (
                <BuildTable
                    data={this.props.pastDueReturnedForEdit}
                    title={'Returned For Edit'}
                    tasksTouched={this.props.tasksTouched}
                />
            );
        } else {
            pastDueTotalCount =
                this.props.pastDueNeedsReview.length +
                this.props.pastDueIncompleteAfterActions.length;
        }

        accordionData.push({
            title: `Past Due (${pastDueTotalCount})`,
            className: 'is-pastDue',
            content: (
                <div>
                    <div className="accordion__teaser">
                        Event Creation Form or After Action is past due in
                        reviewer’s queue
                    </div>

                    <BuildTable
                        data={this.props.pastDueNeedsReview}
                        title={'Needs Review'}
                        tasksTouched={this.props.tasksTouched}
                    />

                    {returnedForEditTable}

                    <BuildTable
                        data={this.props.pastDueIncompleteAfterActions}
                        title={'Incomplete After Action'}
                        tasksTouched={this.props.tasksTouched}
                    />
                </div>
            )
        });

        accordionData.push({
            title: `Incomplete (${this.props.incompleteEvents.length +
                this.props.incompleteAfterActions.length +
                this.props.incompleteAssignedAfterActions.length})`,
            className: '',
            content: (
                <div>
                    <div className="accordion__teaser">
                        Event Creation Form or After Action has not been
                        submitted by creator
                    </div>
                    <BuildTable
                        data={this.props.incompleteEvents}
                        title="Events"
                        tasksTouched={this.props.tasksTouched}
                    />
                    <BuildTable
                        data={this.props.incompleteAfterActions}
                        title="After Actions"
                        tasksTouched={this.props.tasksTouched}
                    />
                    <BuildTable
                        data={this.props.incompleteAssignedAfterActions}
                        title="Assigned After Actions"
                        tasksTouched={this.props.tasksTouched}
                    />
                </div>
            )
        });

        if (
            this.props.userInfo &&
            this.props.userInfo.permissions.resources.Event.includes('Review')
        ) {
            accordionData.push({
                title: `Needs Review (${this.props.needsReviewEvents.length +
                    this.props.needsReviewAfterActions.length})`,
                className: '',
                content: (
                    <div>
                        <div className="accordion__teaser">
                            Event Creation Form or After Action currently in
                            review/approval phase
                        </div>
                        <BuildTable
                            data={this.props.needsReviewEvents}
                            title="Events"
                            tasksTouched={this.props.tasksTouched}
                        />
                        <BuildTable
                            data={this.props.needsReviewAfterActions}
                            title="After Actions"
                            tasksTouched={this.props.tasksTouched}
                        />
                    </div>
                )
            });
        }

        accordionData.push({
            title: `Pending Approval (${this.props.pendingApprovalEvents
                .length + this.props.pendingApprovalAfterActions.length})`,
            className: '',
            content: (
                <div>
                    <div className="accordion__teaser">
                        Event Creation Form or After Action in queue for
                        approval
                    </div>
                    <BuildTable
                        data={this.props.pendingApprovalEvents}
                        title="Events"
                        tasksTouched={this.props.tasksTouched}
                    />
                    <BuildTable
                        data={this.props.pendingApprovalAfterActions}
                        title="After Actions"
                        tasksTouched={this.props.tasksTouched}
                    />
                </div>
            )
        });

        if (!validMcrc) {
            accordionData.push({
                title: `Returned for Edit (${this.props.returnedForEditEvents
                    .length + this.props.returnedForEditAfterActions.length})`,
                className: '',
                content: (
                    <div>
                        <div className="accordion__teaser">
                            Event Creation Form or After Action returned by
                            reviewer for edits/updates
                        </div>
                        <BuildTable
                            data={this.props.returnedForEditEvents}
                            title="Events"
                            tasksTouched={this.props.tasksTouched}
                        />
                        <BuildTable
                            data={this.props.returnedForEditAfterActions}
                            title="After Actions"
                            tasksTouched={this.props.tasksTouched}
                        />
                    </div>
                )
            });
        }

        accordionData.push({
            title: `Rejected Events (${this.props.rejectedEvents.length})`,
            className: '',
            content: (
                <div>
                    <div className="accordion__teaser">
                        Event Creation Form has been rejected by reviewer and
                        will be deleted
                    </div>
                    <BuildTable
                        data={this.props.rejectedEvents}
                        title="Events"
                        tasksTouched={this.props.tasksTouched}
                    />
                </div>
            )
        });

        return this.props.alertsLoading ? (
            <Loading />
        ) : (
            <div>
                <h1 className="headline headline--one">Alerts & Queue</h1>
                <div>
                    {this.props.alertsDataPastDueLength}
                    <Accordion data={accordionData} />
                </div>
            </div>
        );
    }
}

export default Alerts;



// WEBPACK FOOTER //
// ./src/components/alerts/index.js